import { useMemo, ReactElement } from 'react';
import { OrderCard, IOrderCardContainerProps } from '../order-card';
import {
  IOrders,
  ProductOwnerType,
  IProduct,
} from '../../../../../graphql/order/models/get-orders.models';
import { sortByDateDesc } from '../../../../../utils/date/sort-by-date';
import { getBrandsPoints } from '../../../../../utils/order/get-brands-points';

export const useGetOrders = (
  ordersData?: IOrders,
): { orders: ReactElement<IOrderCardContainerProps>[] } => {
  const result = useMemo(() => {
    if (!ordersData?.ordersByAuthId?.length) {
      return { orders: [] };
    }

    const ordersList = ordersData.ordersByAuthId;
    const brandsPoints = getBrandsPoints(ordersData);

    const orders = sortByDateDesc([...ordersList], 'createdDateTime').map((order, index) => {
      const {
        orderDate,
        orderStatus,
        systemId,
        products,
        store,
        id,
        deliveryDate,
        voucher,
        voucherId,
        purchases,
        salesforceStoreInfo,
      } = order;

      const hasKidProfiles = order.products.some(
        (product: IProduct) => product?.productOwner?.type === ProductOwnerType.dependent);
      const dependentProduct = products.find(
        (p: IProduct) => p?.productOwner?.type === ProductOwnerType.dependent,
      );
      // TODO: Refactor same code usage in use-get-orders.tsx and products.tsx
      const productOwner = dependentProduct?.productOwner || products[0]?.productOwner;
      const profile = productOwner?.profile;
      const profileColorIndex = productOwner?.type === ProductOwnerType.dependent ? index : undefined;

      return (
        <OrderCard
          orderDate={orderDate}
          orderStatus={orderStatus}
          orderNumber={systemId}
          orderProducts={products}
          id={systemId}
          brandsPoints={brandsPoints}
          storeData={store}
          orderId={id}
          deliveryDate={deliveryDate}
          bonus={voucher}
          bonusId={voucherId}
          purchases={purchases}
          rating={salesforceStoreInfo?.rating}
          productOwnerType={productOwner?.type}
          profileFirstName={profile?.firstName}
          profileLastName={profile?.lastName}
          profileIsActive={profile?.isActive}
          profileColorIndex={profileColorIndex}
          hasKidProfiles={hasKidProfiles}
        />
      );
    });

    return { orders };
  }, [ordersData]);

  return result;
};
